/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  notes: '笔记',
  note: '笔记',
  saved: '已保存',
  pin: '置顶',
  unpin: '取消置顶',
  unpinFailure: '该笔记不可取消置顶',
  download: '下载',
  share: '分享',
  shareSuccess: '分享成功',
  shareFailure: '分享失败',
  delete: '删除',
  deletePrompt: '你确定要删除吗？',
  search: '搜索',
  syncFailure: '笔记同步失败',
  filter: '搜索',
  keyword: '关键词',
  newNote: '新建笔记',
  createNote: '创建笔记',
  add: '添加',
  created: '创建于',
  modified: '修改于',
  characters: '字符',
  selectNote: '选择笔记',
  selectNoteInformation: '从注释列表中选择注释后，此面板将显示有用的信息和操作',
  welcome: '欢迎使用!',
  selectNoteOrCreate: '选择一个现有的笔记或创建一个新笔记',
  conflict: 'Conflict',
  syncingGotDisabled: '由于未知错误，笔记同步已被禁用',
  notFoundOrNotSynced: '笔记不存在或尚未同步',
}
